export function useUrlHelper () {
  const getQueryParams = () => {
    return window.document.location.search
      .slice(1)
      .split('&')
      .filter(i => i)
      .map(keyVal => keyVal.split('='))
      .reduce((params, [key, val]) => ({
        ...params,
        [key]: val
      }), {})
  }

  const isHome = () => window.document.location.pathname === '/'

  return {
    getQueryParams,
    isHome
  }
}
